import React from 'react';
import ResponsiveResolutionImage from '@components/responsive-resolution-image/responsive-resolution-image';
import * as styles from './blog-section-primary.module.scss';

interface IProps {
  blogTitle: string;
  heroImage: string;
}

const BlogSectionPrimary: React.FC<IProps> = ({
  blogTitle,
  heroImage = null,
}) => {
  return (
    <section className={styles.sectionPrimary}>
      <div className={styles.container}>
        <div className={styles.rowHero}>
          <h1 className={styles.h1}>{blogTitle}</h1>
          <div className={styles.heroImage}>
            {heroImage && (
              <ResponsiveResolutionImage
                url={heroImage}
                title={'Hero image'}
                width={486}
                height={400}
              />
            )}
          </div>
          <div></div>
        </div>
      </div>
    </section>
  );
};

export default BlogSectionPrimary;
